import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://godrive.com.pl/api", // заміни на свою базову адресу
});

// 🔁 Перехоплювач запитів: додає токен з localStorage до кожного запиту
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
